export default "__VITE_ASSET__BAT3qk_9__"